import PropTypes from "prop-types";
import React from "react";
import type { MediaContextType } from "./MediaContext";
import MediaContext from "./MediaContext";

export default class MediaContextProvider extends React.PureComponent<
  { children: React.ReactNode },
  MediaContextType
> {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    playbackRef: null,
    setPlaybackRef: (ref) => {
      this.setState({ playbackRef: ref });
    },
    videoRef: null,
    setVideoRef: (ref) => {
      this.setState({ videoRef: ref });
    },
  } as MediaContextType;

  render() {
    return (
      <MediaContext.Provider value={this.state}>
        {this.props.children}
      </MediaContext.Provider>
    );
  }
}
